import { render } from "./_EditorBOQ.vue?vue&type=template&id=3b8e2c49"
import script from "./_EditorBOQ.vue?vue&type=script&lang=js"
export * from "./_EditorBOQ.vue?vue&type=script&lang=js"

import "./_EditorBOQ.vue?vue&type=style&index=0&id=3b8e2c49&lang=css"
import "./_EditorBOQ.vue?vue&type=style&index=1&id=3b8e2c49&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__